import React from 'react'
import { arrayOf, string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config

const CareerSkills = ({
  bannerDesktop,
  bannerDesktopAlt,
  bannerMobile,
  bannerMobileAlt,
  title,
  skills,
}) => (
  <div id="skills" className="career-skills">
    <SectionContainer
      backgroundColor="#0FC3C4"
      marginTop={80}
      marginBottom={80}
      paddingTop={80}
      paddingBottom={80}
    >
      <Relazsizes
        className="career-skills__banner-mobile"
        dataSrc={bannerMobile}
        alt={bannerMobileAlt}
      />
      <Container fluid>
        <Row>
          <Col md={{ offset: 1, size: 4 }}>
            <Relazsizes
              className="career-skills__banner-dsktp"
              dataSrc={bannerDesktop}
              alt={bannerDesktopAlt}
            />
          </Col>
          <Col md={{ offset: 6, size: 5 }}>
            <SectionTitle title={title} color="#fff" align="left" />
            <ul className="career-skills__list">
              {
                skills.map((skill, idx) => (
                  <li className="career-skills__list-item" key={`ck-li-${idx}`}>
                    <Typography component="p" variant="headline">{ skill }</Typography>
                  </li>
                ))
              }
            </ul>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .career-skills {
          :global(&__banner-mobile) {
            display: block;
            width: 100%;
            margin-top: -80px;
            margin-bottom: 40px;
            @media screen and (min-width: 768px) {
              display: none;
            }
          }
          :global(&__banner-dsktp) {
            display: none;
            @media screen and (min-width: 768px) {
              display: block;
              width: 100%;
              margin-top: -160px;
            }
          }
          :global(&__banner-dsktp.lazyloaded) {
            border-radius: 8px;
            box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.4);
          }
          :global(.campus-section) {
            background-image: url('${assetsUrl}/assets/img/skill-icon.svg');
            background-repeat: no-repeat;
            background-position: bottom right 8.333%;
            background-size: 50%;
            @media screen and (min-width: 768px) {
              background-image: url('${assetsUrl}/assets/img/skill-icon.svg'), url('${assetsUrl}/assets/img/rectangle-element.svg');
              background-repeat: no-repeat, no-repeat;
              background-position: bottom right 8.333%, center left;
              background-size: auto;
            }
          }
          &__list-item {
            color: #fff;
          }
          :global(.Typography) {
            color: #fff;
          }
        }
      `}
    </style>
  </div>
)

CareerSkills.propTypes = {
  bannerDesktop: string,
  bannerDesktopAlt: string,
  bannerMobile: string,
  bannerMobileAlt: string,
  title: string,
  skills: arrayOf(string),
}

export default CareerSkills
